import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { BASIC_SIGNUP_OTP_HASH, HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  phone_number: yup.string().required(),
  otp: yup.string().required(),
});

export const useBasicSignupVerifyOtpMutation = (options = {}) => {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.basicSignupOtp.verify(), {
      phone_number: req.phone_number,
      opt: req.otp, // not a typo
      hash: BASIC_SIGNUP_OTP_HASH,
    });
  }, options);
};
